import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import { ContractCreate } from './ContractCreate';
import { ContractEdit } from './ContractEdit';
import { ContractList } from './ContractList';
import ContractShow from './ContractShow';

const contracts = {
  list: ContractList,
  create: ContractCreate,
  edit: ContractEdit,
  show: ContractShow,
  icon: LibraryBooksIcon,
};

export default contracts;
